import * as React from "react";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  backgroundColor: alpha("#212121", 0.9),
}));

export default function AppAppBar() {
  const navigate = useNavigate();

  return (
    <AppBar position="fixed">
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Button
          variant="text"
          color="inherit"
          sx={{ fontSize: 24, textTransform: "none" }}
          onClick={() => {
            navigate("/");
          }}
        >
          Open Banking
        </Button>
        <Button
          variant="text"
          color="inherit"
          sx={{ fontSize: 18, textTransform: "none" }}
          onClick={() => {
            navigate("/about");
          }}
        >
          About Us
        </Button>
      </Toolbar>
    </AppBar>
  );
}
